import { render, staticRenderFns } from "./oldPhoneDialog.vue?vue&type=template&id=87cb9d38&scoped=true"
import script from "./oldPhoneDialog.vue?vue&type=script&lang=js"
export * from "./oldPhoneDialog.vue?vue&type=script&lang=js"
import style0 from "./oldPhoneDialog.vue?vue&type=style&index=0&id=87cb9d38&prod&lang=scss&scoped=true"
import style1 from "./oldPhoneDialog.vue?vue&type=style&index=1&id=87cb9d38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cb9d38",
  null
  
)

export default component.exports